var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[(_vm.getUserModules)?_c(_vm.component,{tag:"component",attrs:{"routes":_vm.getRoutes,"clubs":_vm.getClubsSorted,"clubs-route":_vm.getClubsRoute,"club-routes":_vm.getClubRoutes(_vm.club)},on:{"change":function($event){_vm.club = $event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }